import { getCookieValue, setCookieFromValue } from "./cookies";

// Nombre del query param del QR, de la cookie y del header que espera la API.
export const REFERRAL_CODE_KEY = "referralcode";

// Ventana de atribución: por cuánto tiempo se le sigue acreditando la reserva
// al referido que originó la visita (el QR que escaneó el huésped).
export const REFERRAL_ATTRIBUTION_DAYS = 30;

const DAY_IN_SECONDS = 24 * 60 * 60;

export const readReferralCode = (search) => {
  const referralCode = new URLSearchParams(search).get(REFERRAL_CODE_KEY);
  return referralCode?.trim() || null;
};

export const getReferralCode = () => getCookieValue(REFERRAL_CODE_KEY) ?? null;

export const persistReferralCode = (search) => {
  const referralCode = readReferralCode(search);
  if (!referralCode) {
    return getReferralCode();
  }
  // Last touch: un QR nuevo reemplaza al anterior y reinicia la ventana.
  setCookieFromValue(REFERRAL_CODE_KEY, referralCode, {
    maxAge: REFERRAL_ATTRIBUTION_DAYS * DAY_IN_SECONDS,
    sameSite: "lax",
    secure: window.location.protocol === "https:",
  });
  return referralCode;
};
